var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentagonEngineering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 156,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.271 78l-43.89 76.5H45.619L1.729 78 45.62 1.5h87.762l43.89 76.5z",
    stroke: "#E0621E",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc5IiBoZWlnaHQ9IjE1NiIgdmlld0JveD0iMCAwIDE3OSAxNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTc3LjI3MSA3OEwxMzMuMzgxIDE1NC41SDQ1LjYxODhMMS43MjkzMyA3OEw0NS42MTg4IDEuNUgxMzMuMzgxTDE3Ny4yNzEgNzhaIiBzdHJva2U9IiNFMDYyMUUiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { SvgPentagonEngineering as ReactComponent };